module.exports = __webpack_public_path__ + "img/singapore.805b0d5.webp";